var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { RadioGroup } from "@mui/material";
import './../ConfigitButtonGroup/ConfigitButtonGroup.scss';
import { RadioComponent } from "../RadioComponent/RadioComponent";
import './RadioGroup.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var ConfigitRadioGroup = function (_a) { var id = _a.id, options = _a.options, showBorders = _a.showBorders, select = _a.select, className = _a.className, other = __rest(_a, ["id", "options", "showBorders", "select", "className"]); var radioSelect = function (option) { if (!option.incompatible) {
    select('', String(option.value));
} }; return /*#__PURE__*/ _jsx(RadioGroup, { className: "px-4", children: options.map(function (option, index) { return /*#__PURE__*/ _jsx(RadioComponent, { click: function () { return radioSelect(option); }, name: "radioCovers", checked: option.assigned ? true : false, value: option.value, disabled: option === null || option === void 0 ? void 0 : option.incompatible, label: option.name }, index); }) }); };
